export default "__VITE_ASSET__33dfc79f__"